.centered {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 28px;
  background:
    radial-gradient(
      circle at 10% 10%,
      color-mix(in srgb, var(--primary) 18%, transparent),
      transparent 32%
    ),
    radial-gradient(
      circle at 90% 85%,
      color-mix(in srgb, var(--accent) 16%, transparent),
      transparent 28%
    ),
    var(--paper);
}

.stateCard {
  width: min(520px, 100%);
  padding: 32px;
  border: var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  box-shadow: var(--shadow);
  text-align: center;
}

.stateCard h1,
.stateCard h2 {
  margin: 14px 0 8px;
  font-family: var(--font-display);
  font-size: clamp(1.55rem, 4vw, 2.2rem);
  line-height: 1.12;
}

.stateCard p {
  color: var(--muted);
  line-height: 1.65;
}

.brandMark {
  position: relative;
  width: 42px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex: none;
  border: var(--border);
  border-radius: 12px;
  background: var(--primary);
  box-shadow: var(--shadow-sm);
}

.brandMark::before {
  content: "";
  position: absolute;
  top: -13px;
  left: 50%;
  width: 8px;
  height: 8px;
  border: 2px solid var(--ink);
  border-radius: 50%;
  background: var(--warning);
  transform: translateX(-50%);
}

.brandMark::after {
  content: "";
  position: absolute;
  top: -7px;
  left: calc(50% - 1.5px);
  width: 3px;
  height: 8px;
  background: var(--ink);
}

.brandMark span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: white;
}

[data-site="launchyouragent"] .brandMark {
  border: 0;
  border-radius: 10px 10px 10px 3px;
  box-shadow: none;
  background: linear-gradient(145deg, var(--primary), #6a82f4);
}

[data-site="launchyouragent"] .brandMark::before,
[data-site="launchyouragent"] .brandMark::after {
  display: none;
}

.spinner {
  width: 34px;
  height: 34px;
  margin: 0 auto;
  border: 4px solid color-mix(in srgb, var(--primary) 20%, transparent);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}

.button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 17px;
  border: var(--border);
  border-radius: var(--radius-sm);
  background: var(--primary);
  box-shadow: var(--shadow-sm);
  color: white;
  font-family: var(--font-display);
  font-weight: 800;
  text-decoration: none;
}

.button:hover:not(:disabled) {
  filter: brightness(1.04);
  transform: translateY(-1px);
}

.buttonSecondary {
  background: var(--surface);
  color: var(--ink);
}

.empty {
  padding: 28px;
  border: 2px dashed color-mix(in srgb, var(--muted) 45%, transparent);
  border-radius: var(--radius);
  background: color-mix(in srgb, var(--surface) 72%, transparent);
  color: var(--muted);
  line-height: 1.6;
  text-align: center;
}

.errorText {
  color: var(--danger);
  font-weight: 700;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

[data-site="launchyouragent"] .button {
  border: 0;
  box-shadow: none;
  font-family: var(--font-body);
  font-weight: 700;
}
